/* eslint-disable no-throw-literal */
(() => {
  class BuyButton extends HTMLElement {
    constructor() {
      super();
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.buyButton = this.querySelector("button");
      this.variantID = this.getAttribute("data-variant-id");
    }

    connectedCallback() {
      this.buyButton.addEventListener("click", async (e) => {
        e.preventDefault();
        const qty = this.getQuantity();
        this.addToCart(qty);
      });
    }

    getQuantity() {
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      if (qtySelector) {
        return qtySelector.querySelector(".js-qty-input").value;
      }
      return 1;
    }

    async addToCart(qty) {
      const formData = {
        items: [
          {
            id: this.variantID,
            quantity: qty,
          },
        ],
      };

      this.cartDrawer.addToCart(formData);
    }
  }

  customElements.define("buy-button", BuyButton);
})();
